export default __webpack_public_path__ + "static/media/title_icon.4819f39c.svg";